// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"9a598ae4","303":"df88de03","453":"87e45203","621":"e057ba94","813":"de4d97c6"}[chunkId] + ".chunk.js";
};